import React, { useId } from 'react';

import { Flex } from '@fhs-legacy/universal-components';
import { designTokens } from 'styles/constants/design-tokens';
import { StoreCardButtonOptions } from 'utils/launchdarkly/variations';
import { STORE_LOCATOR_STORE_LIST_ORDER_BUTTON } from 'utils/test-ids';

import { StoreActionsButton, StoreActionsCard, StoreActionsError } from './components';
import { IStoreActionsViewProps } from './types';

const TEST_IDS = {
  [StoreCardButtonOptions.INFO]: '', // not tested
  [StoreCardButtonOptions.OFFERS]: '', // not tested
  [StoreCardButtonOptions.ORDER]: STORE_LOCATOR_STORE_LIST_ORDER_BUTTON,
};

export const StoreActionsView: React.VFC<IStoreActionsViewProps> = ({ options, message }) => {
  const messageRegionId = useId().replace(/:/g, '');

  return (
    <Flex background={designTokens['background-default']}>
      <StoreActionsCard>
        {options.map(({ id, disabled, icon, text, accessibilityLabel, onClick, loading }) => {
          const isActionDisabled = !!disabled && !!message;
          const accessibilityLabelResolved =
            isActionDisabled && message ? `${accessibilityLabel}, ${message}` : accessibilityLabel;
          return (
            <StoreActionsButton
              testID={TEST_IDS[id]}
              dd-action-name={text}
              key={id}
              disabled={isActionDisabled}
              accessibilityLabel={accessibilityLabelResolved}
              icon={icon}
              text={text}
              onPress={onClick}
              loading={loading}
            />
          );
        })}
      </StoreActionsCard>

      {message ? (
        <StoreActionsError nativeID={messageRegionId} message={message} />
      ) : null}
    </Flex>
  );
};
